import type { GridCustomCellProps } from "@tql/ui-components-react/kendo/grid";
import { Checkbox } from "@tql/ui-components-react/kendo/inputs";

type SelectCellProps = GridCustomCellProps & {
	select?: Record<string | number, boolean>;
	onSelect?: (id: string | number) => void;
	onDeselect?: (id: string | number) => void;
	// Backward compatibility
	onSelectChange?: (id: string | number, selected: boolean) => void;
};

export const SelectCell = <T extends { id: string | number }>({
	select,
	onSelect,
	onDeselect,
	onSelectChange,
	...gridProps
}: SelectCellProps) => {
	const dataItem = gridProps.dataItem as T;

	// Guard against undefined dataItem
	if (!dataItem) {
		return <td {...gridProps.tdProps}></td>;
	}

	const isSelected = select?.[dataItem.id] === true;

	const handleChange = (event: {
		value: boolean;
		syntheticEvent: React.SyntheticEvent;
	}) => {
		if (onSelectChange) {
			// Backward compatibility
			onSelectChange(dataItem.id, event.value);
		} else {
			// New interface
			if (event.value && onSelect) {
				onSelect(dataItem.id);
			} else if (!event.value && onDeselect) {
				onDeselect(dataItem.id);
			}
		}
	};

	return (
		<td {...gridProps.tdProps}>
			<Checkbox checked={isSelected} onChange={handleChange} />
		</td>
	);
};
